import { Link } from "react-router-dom";

export default function PoliticaCookies() {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center px-6 py-10">
      <Link to="/" className="mb-10">
        <img src="/noltrade_gpt.png" alt="Noltrade" className="h-12" />
      </Link>

      <div className="max-w-3xl w-full text-sm text-gray-700 space-y-4">
        <h1 className="text-2xl font-bold mb-4">Política de Cookies</h1>
        <p>Este sitio web utiliza cookies para mejorar tu experiencia...</p>
        <h2 className="font-semibold">1. ¿Qué son las cookies?</h2>
        <p>Pequeños archivos almacenados en tu navegador...</p>
        <h2 className="font-semibold">2. Tipos de cookies</h2>
        <ul className="list-disc ml-5">
          <li>Técnicas</li>
          <li>Analíticas (Google Analytics)</li>
        </ul>
        <h2 className="font-semibold">3. Configuración</h2>
        <p>Puedes gestionarlas desde tu navegador o desde el banner de consentimiento.</p>
        <p className="text-xs text-gray-400 mt-6">Última actualización: mayo 2025</p>
      </div>
    </div>
  );
}
